import React from 'react';

type PointerDownClickHandlerReturn<TElem> = {
    onPointerDown: React.MouseEventHandler<TElem>;
    onPointerUp: React.MouseEventHandler<TElem>;
    onClick: React.MouseEventHandler<TElem>;
};
/**
 * Takes a click handler and returns event handlers that allow handling that
 * click on "pointer down" (instead of the default onClick behavior, "pointer
 * up"), while preserving normal onClick behavior for accessibility / keyboard
 * support
 *  */
export function pointerDownClickHandler<TElem extends Element>(
    eventHandler: React.MouseEventHandler<TElem>
): PointerDownClickHandlerReturn<TElem> {
    let isClickTriggeredByPointerUp = false;
    return {
        onPointerDown: eventHandler,
        onPointerUp: () => {
            isClickTriggeredByPointerUp = true;
        },
        onClick: (event) => {
            if (isClickTriggeredByPointerUp) {
                isClickTriggeredByPointerUp = false;
                return;
            }
            eventHandler(event);
        },
    };
}
